import { Type } from 'class-transformer';
import { IsBoolean, IsInt, IsNotEmpty, IsOptional, IsString, IsUUID, Min, ValidateIf, ValidateNested } from 'class-validator';
import { ALLOWED_USER_AVATAR_MIME_TYPES } from '../../constants';
import { Base64AllowedMimeTypes, MaxBase64FileSize } from '../../decorators';
import { FileUploadDto } from './file.dto';

export class CommunityPerkDto {
	id: string;
	communityId: string;

	name: string;
	description: string;
	url: string;
	avatarId: string;
	onlyForMemberships: boolean;

	order: number;

	createdAt: Date;
	updatedAt: Date;
}

export class ShortCommunityPerkDto {
	id: string;
	// name: string;
	avatarId: string;
	onlyForMemberships: boolean;
	order: number;
	createdAt: Date;
	updatedAt: Date;
}

export class UpsertCommunityPerkDto {
	@IsOptional()
	id?: string;

	@IsUUID()
	@IsNotEmpty()
	communityId: string;

	@IsNotEmpty()
	name: string;

	@IsNotEmpty()
	description: string;

	@IsNotEmpty()
	@IsString()
	url: string;

	@IsNotEmpty()
	@IsBoolean()
	onlyForMemberships: boolean;

	@IsNotEmpty()
	@IsInt()
	@Min(0)
	order: number;

	@IsOptional()
	@IsUUID()
	@IsNotEmpty()
	avatarId?: string;

	@ValidateIf(o => !o.avatarId)
	@IsNotEmpty({ message: 'Sponsor avatar is required' })
	@ValidateNested()
	@Type(() => FileUploadDto)
	@MaxBase64FileSize(20)
	@Base64AllowedMimeTypes(ALLOWED_USER_AVATAR_MIME_TYPES)
	avatarImg?: FileUploadDto | null;
}
